/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ocr_Complete_TextInputs */



/**
* | output |
* | --- |
* | "Found {count} text segments. How would you like to import the results?" |
*
* @param {Ocr_Complete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_complete_text = /** @type {((inputs: Ocr_Complete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Complete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Des segments de texte ${i?.count} ont été trouvés. Comment souhaitez-vous importer les résultats ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Es wurden ${i?.count} Textsegmente gefunden. Wie möchten Sie die Ergebnisse importieren?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sono stati trovati ${i?.count} segmenti di testo. Come desideri importare i risultati?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обнаружено ${i?.count} текстовых сегментов. Как вы хотите импортировать результаты?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se encontraron segmentos de texto ${i?.count}. ¿Cómo desea importar los resultados?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`找到 ${i?.count} 个文本片段。您希望如何导入结果？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 個のテキストセグメントが見つかりました。結果をどのようにインポートしますか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} टेक्स्ट सेगमेंट मिले। आप परिणामों को कैसे आयात करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Foram encontrados ${i?.count} segmentos de texto. Como você gostaria de importar os resultados?`)
	return /** @type {LocalizedString} */ (`Found ${i?.count} text segments. How would you like to import the results?`)
});